import React from 'react';
import { DividerComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';

const DividerComponent = ({ uiComponent }: UiComponentElementInterface<DividerComponentInterface>) => {
  return <hr style={{ borderTopWidth: `${uiComponent?.stroke + 'px'}`, borderStyle: uiComponent?.type, width: '100%', borderTopColor: uiComponent?.color }} />;
};

export default DividerComponent;
